/* "You may also like" slider in the cart drawer.
   Swiper is only included in the layout on the homepage, so it's loaded on
   demand here (once per page) the first time the slider connects. The drawer
   re-renders its contents on every cart change, so each new element simply
   initializes itself again in connectedCallback. */

let swiperLoader;

function loadSwiper(jsUrl, cssUrl) {
  if (typeof Swiper !== 'undefined') return Promise.resolve();
  if (swiperLoader) return swiperLoader;

  swiperLoader = new Promise((resolve, reject) => {
    if (cssUrl && !document.querySelector(`link[href="${cssUrl}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      document.head.appendChild(link);
    }

    const script = document.createElement('script');
    script.src = jsUrl;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return swiperLoader;
}

class CartDrawerRecsSlider extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('.cart-drawer__rec-button[data-variant-id]');
      if (button) this.addToCart(button);
    });
  }

  connectedCallback() {
    loadSwiper(this.dataset.swiperJs, this.dataset.swiperCss)
      .then(() => this.init())
      .catch((e) => console.error(e));
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }

  init() {
    if (this.swiper || !this.isConnected) return;
    const el = this.querySelector('.swiper');
    if (!el) return;

    this.swiper = new Swiper(el, {
      slidesPerView: 3,
      spaceBetween: 5,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: this.querySelector('.cart-drawer__recs-prev'),
        nextEl: this.querySelector('.cart-drawer__recs-next'),
      },
    });
  }

  /* Same request as assets/product-form.js: add the variant and get the
     drawer sections back in one call. Re-rendering the drawer recreates
     <product-recommendations>, which refetches the recs without this product. */
  addToCart(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    const cart = document.querySelector('cart-drawer');
    const variantId = button.dataset.variantId;
    const card = button.closest('.cart-drawer__rec-card');
    card.querySelector('.cart-drawer__rec-error')?.remove();
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'cart-drawer-recs',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.showError(card, response.description || response.message);
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-drawer-recs',
          productVariantId: variantId,
          cartData: response,
        });
        cart.renderContents(response);
      })
      .catch((e) => console.error(e))
      .finally(() => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      });
  }

  showError(card, message) {
    if (!message) return;
    const error = document.createElement('p');
    error.className = 'cart-drawer__rec-error';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    card.appendChild(error);
    setTimeout(() => error.remove(), 4000);
  }
}

if (!customElements.get('cart-drawer-recs-slider')) {
  customElements.define('cart-drawer-recs-slider', CartDrawerRecsSlider);
}
